module.exports = __webpack_public_path__ + "img/switch_dianyun.8a68ec90.png";